import { Capacitor } from '@capacitor/core';

import * as CapacitorStorage from './CapacitorStorage';

const isNative = Capacitor.isNativePlatform();
const Storage = isNative ? CapacitorStorage : localStorage;
const getAuthorization = () => localStorage.getItem('accessToken');

export { Storage, isNative, getAuthorization };
